import CONSTANT from "../../../shared/utils/constant";

export default class CheckVcodeParam {
  constructor (phone, vCode) {
    this.identity = phone
    this.appCode = CONSTANT.APPCODE_PHONE
    this.appServiceCode = CONSTANT.APPSERVICECODE_PWD
    this.verifyCode = vCode
  }
}
